import { superAdminGet, superAdminPut } from './api';

export interface SuperAdminSchoolNotificationsPayload {
  notifications?: { [key: string]: string };
  notificationSchedule?: any;
}

export function getSuperAdminSchoolNotifications(schoolId: string): Promise<SuperAdminSchoolNotificationsPayload> {
  return superAdminGet<SuperAdminSchoolNotificationsPayload>(`/schools/${schoolId}/notifications`);
}

export function updateSuperAdminSchoolNotifications(
  schoolId: string,
  payload: { [key: string]: any }
): Promise<SuperAdminSchoolNotificationsPayload> {
  return superAdminPut<SuperAdminSchoolNotificationsPayload>(`/schools/${schoolId}/notifications`, payload);
}
